module.exports = {
          srcSet: __webpack_public_path__ + "private/f1bb4032e6d7ee2d94d77b75f37e858b-1500.png"+" 1500w",
          images:[ {path: __webpack_public_path__ + "private/f1bb4032e6d7ee2d94d77b75f37e858b-1500.png",width: 1500,height: 1794}],
          src: __webpack_public_path__ + "private/f1bb4032e6d7ee2d94d77b75f37e858b-1500.png",
          toString:function(){return __webpack_public_path__ + "private/f1bb4032e6d7ee2d94d77b75f37e858b-1500.png"},
          
          width: 1500,
          height: 1794
        }